
const VALID_DATE_FORMATS = ['YYYY.MM.DD.', 'YYYY. MM. DD.', 'MM. DD. YYYY', 'YYYY.MM. DD.', 'MM.DD.YYYY'];
export default function dateGreaterThanEqualDirective(app) {
	app.directive('dateGreaterThanEquals', [
		function () {
			let link = function ($scope, $element, $attrs, ctrl) {
				$attrs.$observe('disabled', () => {
					if ($attrs.disabled) {
						ctrl.$setValidity('dateGreaterThanEquals', true);
					}
				});

				const validate = function (viewValue) {
					let haveReturned = false;
					let comparisonModel = $attrs.dateGreaterThanEquals;

					if (!viewValue || !comparisonModel || $attrs.dontValidate == 'true') {
						ctrl.$setValidity('dateGreaterThanEquals', true);
						haveReturned = true;
					}

					const toValiditableFormat = function (input) {
						return input instanceof Date ? moment(input) : moment(input, VALID_DATE_FORMATS);
					};

					if (!haveReturned) {
						let validatableViewValue = toValiditableFormat(viewValue);
						let validatableComparisonValue = toValiditableFormat(comparisonModel);
						ctrl.$setValidity('dateGreaterThanEquals', validatableViewValue.isSameOrAfter(validatableComparisonValue, 'day'));
					}

					return viewValue;
				};

				ctrl.$parsers.unshift(validate);
				ctrl.$formatters.push(validate);

				$attrs.$observe('dateGreaterThanEquals', function () {
					return validate(ctrl.$viewValue);
				});
			};
			return {
				require: 'ngModel',
				link: link
			};
		}
	]);
}
